import { Box, Heading } from '@radix-ui/themes';
import { Link } from 'react-router-dom';

type Preview = { slug: string; label: string; color: string; summary: string };

// One-paragraph summaries surfaced under AcademicWork on /portfolio (and /)
// so a single-page fetch describes every section, not just the active tab.
const PREVIEWS: Preview[] = [
    {
        slug: 'storenvy',
        label: 'STORENVY',
        color: '#78C8A7',
        summary:
            'Digital design work for storenvy.com. Includes featured collection spotlights on the site’s main page, a series of approximately 200 Twitter and Instagram product posts published daily over three months, and Pinterest collection title cards coordinated to seasonal palettes.',
    },
    {
        slug: 'little-red-hen',
        label: 'LITTLE RED HEN',
        color: '#B42029',
        summary:
            'Brand advertising for Little Red Hen Floral, a flower shop in Chico, CA. Includes the Christmas Preview stamp cards and booth fliers (with vendor coordination for print orders) and the Christmas Colors Instagram campaign featuring original poinsettia photography.',
    },
    {
        slug: 'engelbrecht-advertising',
        label: 'ENGELBRECHT ADVERTISING',
        color: '#209EB4',
        summary:
            'Marketing work for Gold Country Casino Resort during a stint at Engelbrecht Advertising. Includes print eco-poster billboards and digital billboards displayed across Northern California, Instagram social media posts, collaborative monthly mailer design (covers and calendar pages), event posters displayed on the casino floor, and double-sided newspaper ads for Appeal Democrat and the Oroville Chamber.',
    },
];

function SectionPreviews() {
    return (
        <>
            {PREVIEWS.map((p) => (
                <Box key={p.slug} p="6">
                    <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: p.color }}>
                        {p.label}
                    </Heading>
                    <Heading as="h4" size="8" weight="regular" mb="4">
                        {p.summary}
                    </Heading>
                    <Link
                        to={`/portfolio/${p.slug}`}
                        style={{
                            fontSize: 24,
                            color: p.color,
                            textDecoration: 'underline',
                            textUnderlineOffset: 4,
                        }}
                    >
                        View {p.label} &rarr;
                    </Link>
                </Box>
            ))}
        </>
    );
}

export default SectionPreviews;
